import Vue from 'vue'

/**
 * 日期格式化
 */
// 格式化为 yyyy-MM-dd hh:mm:ss
function padLeftZero(str) {
    return ('00' + str).substr(str.length);
}
function formatDate(value, fmt) {
    let date = null;

    if (typeof value == 'string') {
        date = new Date(value.replace('-', '/'))
    }
    else {
        date = value
    }

    // yyyy-MM-dd hh:mm:ss
    if (!fmt) fmt = 'yyyy-MM-dd';

    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
    };
    for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str = o[k] + '';
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
        }
    }
    return fmt;
}
Vue.filter('formatDate', formatDate);
export {formatDate};

// 格式化为 xx分钟前
const toDate = input => {
    if (input instanceof Date) return input;
    if (!isNaN(input) || /^\d+$/.test(input)) return new Date(toInt(input));
    input = (input || '').trim().replace(/\.\d+/, '') // remove milliseconds
        .replace(/-/, '/').replace(/-/, '/')
        .replace(/(\d)T(\d)/, '$1 $2').replace(/Z/, ' UTC') // 2017-2-5T3:57:52Z -> 2017-2-5 3:57:52UTC
        .replace(/([\+\-]\d\d)\:?(\d\d)/, ' $1$2'); // -04:00 -> -0400
    return new Date(input);
};
function formatTimeago(value) {
    let date = toDate(value),
        diff = Math.floor((new Date() - date) / 1000);

    diff = diff > 0 ? diff : 0;

    if (diff < 10) return '刚刚'
    else if (diff < 60) return diff + '秒前'
    else if (diff < 60 * 60) return Math.floor(diff / 60) + '分钟前'
    else if (diff < 60 * 60 * 24) return Math.floor(diff / (60 * 60)) + '小时前'
    else return value
}
Vue.filter('formatTimeago', formatTimeago);
export {formatTimeago};

/**
 * money格式化
 */
// 2位小数点
function formatMoney(value, len) {
    var num = parseFloat(value);
    if (isNaN(num))
        num = 0;

    len = parseInt(len)
    if (isNaN(len))
        len = 2

    return num.toFixed(len)
}
Vue.filter('formatMoney', formatMoney);
export {formatMoney};

// 如￥100,000,00.00，代码拷贝自Vue1.x版本
// https://blog.csdn.net/dream_broken/article/details/73481046
function formatCurrency(value, _currency, decimals) {
    value = parseFloat(value);
    if (!isFinite(value) || !value && value !== 0) return '';
    _currency = _currency != null ? _currency : '$';
    decimals = decimals != null ? decimals : 2;
    var stringified = Math.abs(value).toFixed(decimals);
    var _int = decimals ? stringified.slice(0, -1 - decimals) : stringified;
    var i = _int.length % 3;
    var head = i > 0 ? _int.slice(0, i) + (_int.length > 3 ? ',' : '') : '';
    var _float = decimals ? stringified.slice(-1 - decimals) : '';
    var sign = value < 0 ? '-' : '';
    var digitsRE = /(\d{3})(?=\d)/g;
    return sign + _currency + head + _int.slice(i).replace(digitsRE, '$1,') + _float;
}
Vue.filter('formatCurrency', formatCurrency);
export {formatCurrency};

/**
 * 格式化数字
 */
function formatNumber(value) {
    let num = null;
    if (String(value).indexOf('.') >= 0) {
        num = parseFloat(value)
    }
    else {
        num = parseInt(value)
    }
    return isNaN(num) ? 0 : num
}
Vue.filter('formatNumber', formatNumber);
export {formatNumber};



// WEBPACK FOOTER //
// ./src/common/filters.js